export function getExploreName() {
  var userAgent = navigator.userAgent
  if (userAgent.indexOf("WeChat") > -1 || userAgent.indexOf("Weixin") > -1 || userAgent.indexOf("wechatdevtools") > -1) {
    // 微信 miniProgram wechatdevtools
    if (userAgent.indexOf("miniProgram") > -1 || userAgent.indexOf("devtool") > -1) {
      return "WeChatMiniProgram"
    }
    return "WeChat"
  } else if (userAgent.indexOf("AliApp") > -1) {
    if (
      userAgent.indexOf("DingTalk") > -1 &&
      userAgent.indexOf("MiniProgram") > -1
    ) {
      return "DingTalkMini"
    } else if (
      userAgent.indexOf("DingTalk") > -1 &&
      (userAgent.indexOf("DingTalkIDE") > -1 ||
        userAgent.indexOf("AlipayIDE") > -1)
    ) {
      // 小程序开发环境
      return "DingTalkMini"
    } else if (userAgent.indexOf("Alipay") > -1) {
      return "Alipay"
    } else if (userAgent.indexOf("DingTalk") > -1) {
      // 钉钉web
      return "DingTalkWeb"
    }
  } else {
    //   web
    return "web"
  }
}
